module.exports = __webpack_public_path__ + "static/media/23_tn.29f595fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/23_tn.jpg
// module id = 511
// module chunks = 0